
import { useNavigate } from "react-router-dom";
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AlertScreen } from "../../components/AlertScreen";
import { envVariables, separadorMillares } from "../../../../helpers";
import { useInventariosStore } from "../../../../store";
const paginado = Number(envVariables.REACT_APP_PAGINADO);




export const TablaStock = ({ data, chagePage=null, page=0, bodega=false }) => {


    const navigate = useNavigate();
    const { totalInventario } = useInventariosStore();


    const handleOpcionesInfo = (id) => {
        navigate(`/admin/bodega/${id}/stockact`);
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: bodega ? '25%' : '30%' }}>PRODUCTO</TableCell>
                                {bodega && <TableCell sx={{ width: '20%' }}>BODEGA</TableCell>}
                                <TableCell sx={{ width: bodega ? '20%' : '25%' }}>MEDIDA</TableCell>
                                <TableCell sx={{ width: bodega ? '15%' : '20%' }}>STOCK</TableCell>
                                <TableCell sx={{ width: bodega ? '20%' : '25%' }}>PRECIO</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        
                        {data.map( (pro) => (
                            <TableRow key={ pro.id } sx={{cursor:'pointer'}}
                                onClick={() => handleOpcionesInfo(pro.id) } 
                            >
                                <TableCell >{ pro.producto.nombre }</TableCell>
                                {(bodega) && <TableCell >{ pro.bodega.nombre }</TableCell>}
                                <TableCell >{ pro.producto.unidadMedida.nombre  }</TableCell>
                                <TableCell>{ pro.stock }</TableCell>
                                <TableCell>{ `$${separadorMillares(pro.producto.precioCon)}` }</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalInventario / paginado)} disabled={Math.ceil(totalInventario / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay stock por el momento..."/>
        }
        </>
    )
}
